const StarIcon = ({ width = 15, height = 15 }: { width?: number; height?: number }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Star Icon"
    >
        <path
            d="M7.96 0.43C7.86 0.17 7.61 0 7.33 0C7.06 0 6.81 0.17 6.71 0.43L5.37 3.91C5.17 4.44 5.11 4.59 5.02 4.71C4.93 4.83 4.83 4.93 4.71 5.02C4.59 5.11 4.44 5.17 3.91 5.37L0.43 6.71C0.17 6.81 0 7.06 0 7.33C0 7.61 0.17 7.86 0.43 7.96L3.91 9.3C4.44 9.5 4.59 9.56 4.71 9.65C4.83 9.73 4.93 9.84 5.02 9.96C5.11 10.08 5.17 10.23 5.37 10.75L6.71 14.24C6.81 14.5 7.06 14.67 7.33 14.67C7.61 14.67 7.86 14.5 7.96 14.24L9.3 10.75C9.5 10.23 9.56 10.08 9.65 9.96C9.73 9.84 9.84 9.73 9.96 9.65C10.08 9.56 10.23 9.5 10.75 9.3L14.24 7.96C14.5 7.86 14.67 7.61 14.67 7.33C14.67 7.06 14.5 6.81 14.24 6.71L10.75 5.37C10.23 5.17 10.08 5.11 9.96 5.02C9.84 4.93 9.73 4.83 9.65 4.71C9.56 4.59 9.5 4.44 9.3 3.91L7.96 0.43Z"
            fill="#FFC069"
        />
    </svg>
);

export default StarIcon;
